<template>
    <div>
        <div style="height: 500px;">
            <example-description
                subject="MpsDataTable 은 테마를 지원합니다."
                content="테마에 따라 다양한 스타일을 적용할 수 있습니다."
            />
            <v-btn @click="onClickClear">초기화</v-btn>
            <mps-data-table
                ref="table"
                :page="1"
                :count-per-page="5"
                :next="next"
                :headers="headers"
            >
            </mps-data-table>
        </div>
    </div>
</template>

<script>
    import ExampleDescription from "@/components/example/ExampleDescription";
    import MpsDataTable from "@/assets/plugins/mps-form-table/component/mps-data-table/MpsDataTable";
    import {IMAGES} from "@/constants/icons";
    import utilManager from "@/assets/plugins/mps-common/util/util-manager";

    export default {
        name: "ExampleMpsDataTable",
        components: {MpsDataTable, ExampleDescription},
        data() {
            return {
                headers: [
                    {
                        text: "아이디",
                        key: "id",
                        width: 100,
                        sortable: true,
                        class: (v, item) => item.id % 10 === 0 ? "color__blue" : undefined,
                        tooltip: {
                            src: (v, item) => item.id % 10 === 0 && utilManager.getImgUrl(IMAGES.ARROW),
                            text: (v, item) => item.text,
                            color: (v, item) => "indigo",
                        },
                        align: "left"
                    },
                    {
                        text: "내용",
                        key: "text",
                        width: 300,
                        editable: true,
                        sortable: true,
                        icons: [
                            {
                                icon: (v, item) => "mdi-pencil",
                                callback: (v, item) => alert(item.text),
                                description: (v, item) => "테스트",
                            },
                            {
                                src: (v, item) => utilManager.getImgUrl(IMAGES.ARROW),
                                callback: (v, item) => alert(item.text),
                            },
                        ],
                    },
                    {
                        text: "마지막 컬럼",
                        key: "addit",
                        width: 300,
                        children: [
                            {
                                text: "추가1",
                                key: "additional1"
                            },
                            {
                                text: "추가2",
                                key: "additional2"
                            },
                        ],
                    },
                    {
                        key: "expanded",
                        expanded: (item) => { console.log("expanded " + item.id)},
                        unexpanded: (item) => { console.log("unexpanded " + item.id)},
                    },
                ],

                items: [],
            }
        },
        created() {
            for (let i = 0; i < 30; i++) {
                this.items.push({
                    id: i,
                    text: "테스트" + i,
                    additional1: "추가 내용1-" + i,
                    additional2: "추가 내용2-" + i,
                },);
            }
        },
        mounted() {
        },
        methods: {
            next(pageNumber, pageSize, obj) {
                return this.items.slice(obj.startPage, obj.endPage);
            },

            onClickClear() {
                this.$refs.table.clearAndNext();
            },

            onClickRow(item) {
                alert(item.text);
            },
        }
    }
</script>

<style>
    .color__blue {
        color: #0C98FE;
        font-weight: bold;
    }
</style>